"use client";

import { useEffect } from "react";
import { postBookingEmbedHeight } from "./public-booking-embed-height";

/** Resize parent iframe when a portaled overlay opens or closes. */
export function useNotifyBookingEmbedHeightWhenOpen(open: boolean): void {
  useEffect(() => {
    postBookingEmbedHeight();
    if (!open) return;

    const frameId = window.requestAnimationFrame(() => {
      postBookingEmbedHeight();
    });

    return () => {
      window.cancelAnimationFrame(frameId);
    };
  }, [open]);
}
